import React, { useEffect } from 'react'
import { CoreButton, CoreIconButton, CoreTextField } from 'src/components/core'
import {
  CircularProgress,
  TextField,
  withStyles,
  Typography,
  Popover,
  Tooltip,
} from '@material-ui/core'
import { Icon } from '@iconify/react'
import { useSelector, useDispatch } from 'react-redux'
import { useHistory } from 'react-router-dom'
import ThemeSettingsDrawer from 'src/components/theme-settings'
import SettingsDrawer from 'src/components/settings-drawer'
import AnalyticsDrawer from 'src/components/analytics-drawer'
import {
  themeDrawerOpen,
  settingsDrawerOpenSuccess,
  analyticsDrawerOpen,
} from 'src/reducers/course/action'
import styles from './styles'
import { PatchContent, PatchData } from 'src/model/patch'
import { coursePatchAction } from 'src/reducers/course/action'
import SharePopover from 'src/components/share-popover'
import CoursePreview from 'src/components/preview'
import { track } from '@amplitude/analytics-browser'
const CourseToolBar = props => {
  const { classes } = props
  const history = useHistory()
  const dispatch = useDispatch()
  const course = useSelector(state => state.course.course)
  const [title, setTitle] = React.useState(course?.name)
  const [anchorEl, setAnchorEl] = React.useState(null)
  const [isModalOpen, setIsModalOpen] = React.useState(false)

  const handleOpenModal = () => {
    track('Course_Preview_Clicked', {
      courseId: course.id,
      courseName: course.name,
    })
    setIsModalOpen(true)
  }

  const handleCloseModal = () => {
    setIsModalOpen(false)
  }

  useEffect(() => {
    if (course) {
      setTitle(course.name)
    }
  }, [course])

  const redirectToCollection = () => {
    if (course.courseCollectionId) {
      history.push(`/collection/${course.courseCollectionId}`)
    } else {
      history.push(`/courses`)
    }
  }
  const handleGetAnalytics = () => {
    dispatch(analyticsDrawerOpen())
  }
  const handleTitleChange = event => {
    setTitle(event.target.value)
  }

  const onBlurTitle = value => {
    if (course?.name !== value) {
      const patchSource = new PatchData(null, course.id)
      patchSource.addContent(
        new PatchContent(value, 'name', PatchData.OPERATION_REPLACE),
      )
      dispatch(coursePatchAction(patchSource, () => {}))
    }
  }

  const saving = useSelector(state => state.card.editorLoading)
  const handleClickShare = event => {
    setAnchorEl(event.currentTarget)
  }
  const handleClose = () => {
    setAnchorEl(null)
  }
  const open = Boolean(anchorEl)
  const id = open ? 'simple-popover' : undefined
  const [hoveredCourseNaming, setHoveredCourseNaming] = React.useState(false)
  const editorErrorState = useSelector(state => state.card.editorError)
  return (
    <>
      <div className={classes.toolbarFlexStyle}>
        <Tooltip title="Back" placement="bottom">
          <CoreIconButton
            size="small"
            color="secondary"
            variant="text"
            onClick={redirectToCollection}
          >
            <Icon icon="ic:round-chevron-left" />
          </CoreIconButton>
        </Tooltip>

        {course && (
          <div
            onMouseEnter={() => {
              setHoveredCourseNaming(true)
            }}
            onMouseLeave={() => {
              setHoveredCourseNaming(false)
            }}
            style={{
              display: 'flex',
              flexDirection: 'row',
              gap: 4,
              alignItems: 'center',
              width: '100%',
            }}
          >
            <CoreTextField
              className={classes.textfield}
              InputProps={{
                className: classes.textfieldInput,
              }}
              inputProps={{
                style: { padding: 8, backgroundColor: 'transparent' },
              }}
              onBlur={e => onBlurTitle(e.target.value)}
              onChange={e => handleTitleChange(e)}
              value={title}
              color="primary"
              marginTop={false}
            />
            <Icon
              icon="fluent:edit-16-regular"
              fontSize={16}
              color="#002E47"
              style={{ display: hoveredCourseNaming && 'none' }}
            />
            <Icon
              icon="fluent:edit-24-filled"
              fontSize={16}
              color="#002E47"
              style={{ display: hoveredCourseNaming ? 'block' : 'none' }}
            />
          </div>
        )}
      </div>
      <div className={classes.toolbarFlexStyle}>
        <div style={{ flexGrow: 1 }}></div>

        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            gap: 4,
            alignItems: 'center',
            justifyContent: 'center',
            width: '80px',
            height: '36px',
          }}
        >
          {saving ? (
            <Tooltip title="Changes are being saved...">
              <CircularProgress size={18} color="primary" />
            </Tooltip>
          ) : (
            <Tooltip title="All changes saved">
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'row',
                  gap: 4,
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
              >
                {editorErrorState ? (
                  <Icon
                    icon="iconamoon:cloud-error-light"
                    fontSize={18}
                    color="ED4245"
                  />
                ) : (
                  <Icon
                    icon="ion:cloud-done-outline"
                    color="29D25D"
                    fontSize={18}
                  />
                )}

                <Typography
                  fontSize="13px"
                  fontWeight={400}
                  color="#002E47"
                  fontFamily={'Inter'}
                  style={{
                    marginLeft: '4px',
                  }}
                >
                  {editorErrorState ? 'Unsaved' : 'Saved'}
                </Typography>
              </div>
            </Tooltip>
          )}
        </div>
        <div
          style={{
            display: 'flex',
            borderRight: '1px solid #E0E0E0',
            height: '20px',
          }}
        ></div>
        <Tooltip title="Mini-Course Theme">
          <CoreIconButton
            size="small"
            color="secondary"
            variant="text"
            onClick={() => dispatch(themeDrawerOpen())}
          >
            <Icon icon="ph:palette" />
          </CoreIconButton>
        </Tooltip>
        <Tooltip title="Mini-Course Settings">
          <CoreIconButton
            size="small"
            color="secondary"
            variant="text"
            onClick={() => dispatch(settingsDrawerOpenSuccess())}
          >
            <Icon icon="solar:settings-outline" />
          </CoreIconButton>
        </Tooltip>
        <Tooltip title="Mini-Course Report">
          <CoreIconButton
            size="small"
            color="secondary"
            variant="text"
            onClick={handleGetAnalytics}
          >
            <Icon icon="uim:analytics" />
          </CoreIconButton>
        </Tooltip>
        <CoreButton
          size="small"
          color="primary"
          variant="text"
          onClick={handleOpenModal}
        >
          Preview
        </CoreButton>
        <CoreButton
          size="small"
          color="primary"
          variant="contained"
          onClick={handleClickShare}
        >
          Share
        </CoreButton>
        <Popover
          id={id}
          open={open}
          anchorEl={anchorEl}
          onClose={handleClose}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'right',
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'right',
          }}
          PaperProps={{
            style: {
              padding: '16px',
              borderRadius: '16px',
              width: '400px',
            },
          }}
        >
          <SharePopover />
        </Popover>
        <ThemeSettingsDrawer />
        <SettingsDrawer />
        <AnalyticsDrawer />
        <CoursePreview
          handleCloseModal={handleCloseModal}
          isModalOpen={isModalOpen}
        />
      </div>
    </>
  )
}

export default withStyles(styles)(CourseToolBar)
